export interface BatteryMetricItem {
	label: string;
	value: number;
	displayValue?: string;
	severity?: "Low" | "Moderate" | "High" | "Critical";
	percentage?:number;
	colorClass?: string;
	showPercentage?: boolean;
	name?: string;
}

export type Theme = 'blue' | 'yellow' | 'purple';

export interface LegendItem {
	label: string;
	severity?: BatteryMetricItem["severity"];
	colorClass?: string;
	type?: 'dot' | 'bar';
}

// Battery exception keys that only apply to lead-acid batteries - hidden on lithium-only sites
export const LEAD_ACID_ONLY_EXCEPTION_KEYS: ReadonlySet<string> = new Set([
	'batteries_with_low_water_level',
	'batteries_with_messed_equalization_charge',
	'potential_sulfated_batteries',
	'batteries_with_potential_weak_cells',
	'low_temperature_batteries',
	'high_temperature_batteries',
]);

export interface LegendGroup {
	title: string;
	items: LegendItem[];
}